import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  topRoot: {
    background:
      "linear-gradient(359.82deg, rgba(53, 231, 255, 0) 0.15%, rgba(53, 164, 255, 0.25) 99.85%)",
    paddingTop: theme.spacing.space16,
    marginTop: theme.spacing.space16,
  },
  headerTitle: {
    "&.topGame": {
      display: "flex",
      gap: 5,
      marginTop: 0,
    },
    "&.playAndWin": {
      marginBottom: theme.spacing.space16,
    },
  },
  content: {
    display: "flex",
    gap: theme.spacing.space12,
    overflowX: "auto",
    overflowY: "hidden",
    whiteSpace: "nowrap",
    scrollBehavior: "smooth",
    padding: `0px ${theme.spacing.space16}px`,
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));
